import React, {useContext, useEffect, useState} from 'react';
import PackageListItem from "../components/Package-list-item/Package-list-item";
import {axios} from "../axios";
import {LangContext} from "../App";
import Seo from "../components/Seo/Seo";


const Packages = () => {
    const [data,setData] = useState([])
    const lang = useContext(LangContext)
    useEffect(()=>{
        axios.get(`${lang}/tour-package`)
            .then( res => setData(res.data.tours))
            .catch(() => setData([]))
    },[lang])
    return (
        <div className='packages'>
            <Seo pageKey="packages" />
            <div className="center-wrapper">
                <div className="packages-list">
                    {data?.map(e => <PackageListItem key={e.id} tour={e} path='tour-package'/>)}
                </div>
            </div>
        </div>
    );
};

export default Packages;